//internal
import Footer from "../Components/Footer";
import Header from "../Components/Header";

export default function BaseLayout({ children }) {
  return (
    <>
      <Header />
      <main className="overflow-hidden ">{children}</main>
      <Footer />
    </>
  );
}
